const _route = {
    _admin_login: '/',
    _admin_dashboard: '/admin/dashboard',
    _admin_client: '/admin/client',
    _admin_create_client: '/admin/client/create-client',
    _admin_create_admin: '/admin/administrator/create-admin',
    _admin_view_client: '/admin/client/:id',
    _admin_administrator: '/admin/administrator',
    _admin_view_administrator: '/admin/administrator/:id',
    _not_found: '*',

}

export default _route